import React, { useState } from "react";
import AuthLayout from "./AuthLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, IconButton, InputAdornment, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useResetPasswordMutation } from "../../services/auth";
import { showError, showToast } from "../../constants/toasts";
import { removeFromStorage } from "../../helpers/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";

const ResetPassword = () => {
  const { state } = useLocation();
  const [resetPassword] = useResetPasswordMutation();

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      newpassword: "",
      confirmpassword: "",
      email: state?.email,
    },
    validationSchema: Yup.object({
      newpassword: Yup.string()
        .label("new Password")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/,
          "Password must be at least 8 characters long and include 1 uppercase, 1 lowercase, and 1 special character."
        )
        .required("New password is required."),

      confirmpassword: Yup.string()
        .oneOf([Yup.ref("newpassword")], "Passwords must match.")
        .required("Confirm password is required."),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);
      const body = {
        email: state?.email,
        new_password: formik.values.newpassword,
        confirm_password: formik.values.confirmpassword,
      };

      try {
        const response = await resetPassword(body).unwrap();

        if (response?.status === 200) {
          navigate("/");
          showToast("Password reset successfully");
          removeFromStorage(STORAGE_KEYS.credentials);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        showError(error?.data?.message || "");
      }
      formik.setSubmitting(false);
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleClickShowPassword1 = () => {
    setShowConfirmPassword((prev) => !prev);
  };
  const handleMouseDownPassword1 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Reset Password</h2>
        <p>Create a secure password to protect your account.</p>
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label>New Password</label>
            <TextField
              placeholder="Enter New Password"
              fullWidth
              hiddenLabel
              type={showPassword ? "text" : "password"}
              name="newpassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.newpassword && formik.errors.newpassword
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="eye_btn">
                    <IconButton
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="control_group">
            <label>Confirm Password</label>
            <TextField
              placeholder="Enter Confirm Password"
              fullWidth
              hiddenLabel
              type={showConfirmPassword ? "text" : "password"}
              name="confirmpassword"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.confirmpassword && formik.errors.confirmpassword
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="eye_btn">
                    <IconButton
                      aria-label={
                        showConfirmPassword ? "Hide password" : "Show password"
                      }
                      onClick={handleClickShowPassword1}
                      onMouseDown={handleMouseDownPassword1}
                      edge="end"
                    >
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" type="submit">
              Submit
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <span className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </span>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
